import React from 'react';
import SKIN_NAME from 'src/enums/skinName';
import { QL2Logo } from './logo/QL2Logo';
import { ExpretioLogo } from './logo/ExpretioLogo';
import { CargillLogo } from './logo/CargillLogo';
import { RivalisLogo } from './logo/RivalisLogo';

const { Standard, DarkMode, ExpretioXCS, Cargill, ExpretioRivalis } = SKIN_NAME;

type CompanyLogoProps = {
  skinName: SKIN_NAME;
  collapsed: boolean;
};

const CompanyLogo: React.FC<CompanyLogoProps> = ({ skinName, collapsed }) => {
  switch (skinName) {
    case Standard:
    case DarkMode:
      return <QL2Logo collapsed={collapsed} />;

    case ExpretioXCS:
      return <ExpretioLogo collapsed={collapsed} />;

    case Cargill:
      return <CargillLogo collapsed={collapsed} />;
    case ExpretioRivalis:
      return <RivalisLogo collapsed={collapsed} />;

    default:
      return <QL2Logo collapsed={collapsed} />;
  }
};

export default CompanyLogo;
